import { isEqual } from '@javascript/components/vehicle_search/helpers/vehicleSearchHelpers';
import { useEffect, useRef } from 'react';
import { useInstantSearch } from 'react-instantsearch';

function isFirstPage(page?: number): boolean {
  return page === undefined || page === 0;
}

export function ScrollToTopOnFirstPage() {
  const { indexUiState } = useInstantSearch();
  const previousUiStateRef = useRef<{ page?: number } | null>(null);

  useEffect(() => {
    const currentPage = indexUiState?.page;
    const previousPage = previousUiStateRef.current?.page;

    const isCurrentFirstPage = isFirstPage(currentPage);
    const wasPreviousFirstPage = isFirstPage(previousPage);

    let shouldScroll = false;

    if (isCurrentFirstPage && !wasPreviousFirstPage) {
      //i.e page 1 to 0
      shouldScroll = true;
    } else if (isCurrentFirstPage && wasPreviousFirstPage) {
      // Still on page 0 (results never get above 24), but something else in the state changed
      if (!isEqual(previousUiStateRef.current, indexUiState)) {
        shouldScroll = true;
      }
    }

    if (shouldScroll) {
      window.scrollTo({ top: 0, behavior: 'auto' });
    }

    previousUiStateRef.current = indexUiState;
  }, [indexUiState]);

  return null;
}
